import {
  MultipleChoiceNodeData,
  MediaData,
  MultipleChoiceMediaData,
  MultipleChoiceData,
} from '../../../types/quiz';
import { getQuestion, mapBaseData, parseMainExp } from './utils';

/**
 * MultipleChoiceData.
 */
export const mapMultipleChoiceData = ({
  data,
  mediaData,
}: {
  data: MultipleChoiceNodeData;
  mediaData: MediaData<MultipleChoiceMediaData[]>;
}): MultipleChoiceData => {
  return {
    ...mapBaseData(data),
    question: getQuestion<MultipleChoiceMediaData[]>(data.q, mediaData),
    answerOrder: Number.parseInt(data.ao, 10),
    mainExplanation:
      parseMainExp<MultipleChoiceMediaData[]>(data.e, mediaData) || '',
    keyTakeaway:
      parseMainExp<MultipleChoiceMediaData[]>(data.kp, mediaData) || '',
    answers: data.a.map((a) => ({
      explanation: a.e || '',
      text: parseMainExp(a.v, mediaData),
      isCorrect: a.c === '1',
    })),
  };
};
